import Constant from "@/common/constant/Constant";
import Utils from "@/common/utils/utils";
import { getLinkDownloadFileFromS3 } from "../common/FileUploaded";

const getChatPostAttachFiles = (attachFiles) => {
    if (!attachFiles) return [];
    
    return attachFiles?.filter(attach =>
        Utils.getPrefixOfId(attach?.originId) === Constant.ID_PREFIX.CHAT_POST
    ) || [];
};

const separateImageAndOtherFiles = (fileList) => {
    if (!fileList) return { images: [], others: [] };
    
    const images = fileList
        ?.filter(item => Utils.isImageFile(item.fileInfo.fileName))
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)) || [];

    const others = fileList
        ?.filter(item => !Utils.isImageFile(item.fileInfo.fileName))
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)) || [];

    return { images, others };
};

const getImageLinks = (attachData, detailTicket) => {
    if (!attachData || !detailTicket) return { imgThumbnailLink: null, imgLink: null };
    
    const imageData = {
        fileUrl: attachData.fileInfo.fileUrl,
        id: attachData.originId,
        content: attachData.fileInfo.fileName,
        type: Constant.S3_FILE_TYPE.TICKET_FILE
    };

    const imgThumbnailLink = getLinkDownloadFileFromS3(
        {
            ...imageData,
            thumbnailInfo: JSON.stringify(attachData.thumbnailInfo),
            type: Constant.S3_FILE_TYPE.TICKET_FILE
        },
        detailTicket,
        null,
        Constant.ATTACH_FILE.VIEW_TICKET_DETAIL
    );

    const imgLink = getLinkDownloadFileFromS3(imageData, detailTicket);

    return { imgThumbnailLink, imgLink };
};


export { getChatPostAttachFiles, separateImageAndOtherFiles, getImageLinks };